import { WalletIcon } from 'cokitchen-icons';
import React, { useEffect, useState } from 'react';
import { formatCurrency } from 'utils/functions';
import { ReactComponent as PaystackIcon } from 'assets/icons/paystack-icon.svg';
import useDashboardContext from 'contexts/dashboard.context';
import { PaymentActionType } from 'contexts/dashboard.context/context';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import moment from 'moment';
import { ReactComponent as MasterCardIcon } from 'assets/icons/mastercard-icon.svg';
import { ReactComponent as VisaIcon } from 'assets/icons/visa-icon.svg';
import { ReactComponent as VerveIcon } from 'assets/icons/verve-icon.svg';

export interface PaymentMethod {
  use_business_wallet: boolean;
  use_bani: boolean;
  use_paystack: boolean;
  [key: string]: boolean;
}

type Props = {
  handleUpdatePaymentMethod: (paymentMethod: PaymentMethod) => void;
  amount: number;
};
const PaymentOptions = ({ handleUpdatePaymentMethod, amount }: Props) => {
  const { setPaymentType, paymentCards, companyWalletDetails } = useDashboardContext();
  const balance = companyWalletDetails?.available_balance;
  const [insufficientBalance, setInsufficientBalance] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState({
    use_business_wallet: false,
    use_bani: false,
    use_paystack: false
  });
  const toggleFundWallet = () => {
    setShowFundWalletModal(!showFundWalletModal);
  };
  useEffect(() => {
    if (balance) {
      setInsufficientBalance(Number(balance) < amount);
    }
  }, [amount]);
  const changeActive = (option: PaymentActionType) => {
    setPaymentType(option);
  };

  const handleSetPaymentMethod = (payMethod: string) => {
    const updatedPaymentMethod = {} as PaymentMethod;

    Object.keys(paymentMethod).forEach((key) => {
      updatedPaymentMethod[key] = key === payMethod;
    });

    setPaymentMethod(
      updatedPaymentMethod as {
        use_business_wallet: boolean;
        use_bani: boolean;
        use_paystack: boolean;
      }
    );
  };
  useEffect(() => {
    handleUpdatePaymentMethod(paymentMethod);
  }, [paymentMethod]);
  const getCardIcon = (cardName: string) => {
    switch (cardName.toLowerCase().trim()) {
      case 'mastercard':
        return <MasterCardIcon className='mr-4 ml-2' />;
      case 'verve':
        return <VerveIcon />;
      default:
        return <VisaIcon className='mr-3 ml-2' />;
    }
  };

  return (
    <div className='w-full rounded-md border border-[#EFF0F0] mb-2'>
      <div
        onClick={() => {
          changeActive('wallet');
          handleSetPaymentMethod('use_business_wallet');
        }}
        className={`flex justify-between items-center py-4 px-4 border-b border-b-[#EDEDED] cursor-pointer`}>
        <div className='flex gap-3 items-center'>
          <WalletIcon className='w-5 h-5 text-[rgb(0,195,247)]' />
          <div className=' '>
            <p className='text-sm text-[#2E3031] font-medium'>Pay via Wallet</p>
            <p className='text-[#6F7376] text-xs'>
              Balance:{' '}
              <span className={insufficientBalance ? 'text-[#E60A2B]' : ''}>
                {formatCurrency(Number(balance))}
              </span>
              {insufficientBalance && (
                <span className={insufficientBalance ? 'text-[#E60A2B]' : ''}> (Insufficient)</span>
              )}
            </p>
          </div>
        </div>
        {insufficientBalance ? (
          <div
            onClick={toggleFundWallet}
            className='text-[#0080E5] text-xs mt-2 cursor-pointer font-medium'>
            Fund wallet
          </div>
        ) : (
          <div
            className={`w-[14px] h-[14px] rounded-full ${
              paymentMethod.use_business_wallet
                ? 'border-4  border-[#E60A2B]'
                : 'border border-[#D8D9DA]'
            }`}></div>
        )}
      </div>
      <div
        onClick={() => {
          handleSetPaymentMethod('use_paystack');
          changeActive('paystack');
        }}
        className='flex justify-between items-center py-4 px-4 border-b border-b-[#EDEDED]'>
        <div className='flex gap-3 items-center'>
          <PaystackIcon />
          <div>
            <p className='text-sm text-[#2E3031] font-medium'>Add a bank card</p>
            {paymentCards?.map((card) => (
              <div
                key={card.id}
                className='flex items-center justify-between py-4 border-b border-gray-13'>
                <div className='flex gap-5 items-center'>
                  {getCardIcon(card.card_name)}
                  <div>
                    <p className='font-medium'>Ending in ***{card.last_four_digit}</p>
                    <p className='text-xs font-[#6F7376] font-[400]'>
                      Added {moment(card.created_at).format('MMMM YYYY')}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={`w-[14px] h-[14px] rounded-full  ${
            paymentMethod.use_paystack ? 'border-4  border-[#E60A2B]' : 'border border-[#D8D9DA]'
          }`}></div>
      </div>
      <div
        onClick={() => {
          handleSetPaymentMethod('use_bani');
          changeActive('transfer');
        }}
        className='flex justify-between items-center  py-4 px-4'>
        <div className='flex gap-3 items-center'>
          <PaystackIcon />
          <div>
            <p className='text-sm text-[#2E3031] font-medium'>Pay via transfer</p>
            <p className='text-[#6F7376] text-xs'>Powered by Bani</p>
          </div>
        </div>
        <div
          className={`w-[14px] h-[14px] rounded-full  ${
            paymentMethod.use_bani ? 'border-4  border-[#E60A2B]' : 'border border-[#D8D9DA]'
          } `}></div>
      </div>
      <div className='flex flex-col mb-6'></div>
      <FundWalletModal isOpen={showFundWalletModal} onClose={toggleFundWallet} />
    </div>
  );
};

export default PaymentOptions;
